import { jsxs as o, Fragment as l, jsx as e } from "react/jsx-runtime";
import { amenityIcons as c, SvgIcnGeneric as y } from "../../js/utils-BBROaCB1.js";
import * as u from "react";
import { useMemo as C } from "react";
import a from "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import p from "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import f from "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import A from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import h from "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { labelToEnum as g } from "@propify-tenant-client/common";
import { AmenityTypesHooks as L } from "@propify-tenant-client/services";
const T = (i) => /* @__PURE__ */ u.createElement("svg", { width: 14, height: 10, viewBox: "0 0 14 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i }, /* @__PURE__ */ u.createElement("path", { d: "M12.8359 1.89062C12.9818 2.03646 13.0547 2.21354 13.0547 2.42187C13.0547 2.63021 12.9818 2.80729 12.8359 2.95312L7.17969 8.60938L6.11719 9.67188C5.97135 9.81771 5.79427 9.89062 5.58594 9.89062C5.3776 9.89062 5.20052 9.81771 5.05469 9.67188L3.99219 8.60938L1.16406 5.78125C1.01823 5.63542 0.945312 5.45833 0.945312 5.25C0.945312 5.04167 1.01823 4.86458 1.16406 4.71875L2.22656 3.65625C2.3724 3.51042 2.54948 3.4375 2.75781 3.4375C2.96615 3.4375 3.14323 3.51042 3.28906 3.65625L5.58594 5.96094L10.7109 0.828125C10.8568 0.682292 11.0339 0.609375 11.2422 0.609375C11.4505 0.609375 11.6276 0.682292 11.7734 0.828125L12.8359 1.89062Z", fill: "#FF7A00" })), S = "#0C57A5", b = A({
  amenity: {
    display: "flex",
    alignItems: "center",
    gap: 15
  },
  featuredAmenity: {
    display: "grid",
    gap: 15,
    border: "1px solid #eaeaea",
    borderRadius: 6,
    boxShadow: "0 1px 5px rgba(0, 0, 0, 0.15)",
    textAlign: "center",
    justifyContent: "center",
    padding: "15px 0 10px 0",
    color: S
  },
  unitSubTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#2C5982"
  }
}), bt = ({ list: i }) => {
  const m = b(), { data: s = [] } = L.useAmenityTypes(), n = C(() => {
    const t = i.map((r) => {
      var d;
      return {
        ...r,
        name: (d = s.find((x) => x.id === r.typeId)) == null ? void 0 : d.name
      };
    });
    return {
      featured: t.filter((r) => r.featured),
      notFeatured: t.filter((r) => !r.featured)
    };
  }, [s, i]);
  return /* @__PURE__ */ o(l, { children: [
    n.featured.length > 0 && /* @__PURE__ */ o(l, { children: [
      /* @__PURE__ */ e(a, { my: 2, children: /* @__PURE__ */ e(h, { className: m.unitSubTitle, children: "Featured Amenities" }) }),
      /* @__PURE__ */ e(p, { container: !0, spacing: 2, children: n.featured.map((t) => {
        const r = c[g(t.name || "")] ? c[g(t.name)] : y;
        return /* @__PURE__ */ e(p, { item: !0, spacing: 1, xs: 6, sm: 4, md: 3, lg: 3, children: /* @__PURE__ */ o(a, { className: m.featuredAmenity, children: [
          t.name && /* @__PURE__ */ e(r, { width: 100 }),
          /* @__PURE__ */ e(f, { children: t.name })
        ] }) }, t.id);
      }) })
    ] }),
    /* @__PURE__ */ e(a, { my: 2, children: /* @__PURE__ */ e(h, { className: m.unitSubTitle, children: "Other Amenities" }) }),
    /* @__PURE__ */ e(p, { container: !0, spacing: 2, children: n.notFeatured.map((t) => /* @__PURE__ */ o(p, { item: !0, className: m.amenity, xs: 6, sm: 4, lg: 3, children: [
      /* @__PURE__ */ e(T, {}),
      /* @__PURE__ */ e(f, { children: t.name })
    ] }, t.id)) })
  ] });
};
export {
  bt as default
};
//# sourceMappingURL=Amenities.js.map
